import styles from './ActionBar.css'
import {reduxForm, Field, initialize, change, formValueSelector} from 'redux-form'
import {connect} from 'react-redux'
import DropdownOutlet from 'components/Fields/ReduxForm/DropdownOutlet'
import DropdownSelect from 'components/Fields/ReduxForm/DropdownSelect'
import * as actTableManagement from 'actions/tableManagement'
import {askConfirmAction} from 'actions/confirm-action'
import _isEqual from 'lodash/isEqual'
import _orderBy from 'lodash/orderBy'
import {GRID_MAX} from '../constants'
import * as actNotif from 'actions/notifications'
import MenuTitle from 'components/MenuTitle'

class ActionBar extends React.Component {
  render () {
    let {outlets, groups, groupDetail, disableSaveLayoutButton} = this.props
    let groupsSort = _orderBy(groups, ['name'], ['asc'])
    let _id = groupDetail ? groupDetail.id : 0
    let _name = groupDetail ? groupDetail.name : 'Select Group'
    let _active = groupDetail ? (groupDetail.active ? 'Active' : 'Inactive') : 'N.A.'

    groupsSort = groupsSort.filter(group => group.id !== _id)
    const fieldDisabled = groupsSort.length === 0
    let activeStyle = groupDetail ? (groupDetail.active ? styles['text-active'] : styles['text-inactive']) : styles['text-ongoing']
    return (<div>
      <MenuTitle menuTitle='Table Map' />
      <div className='col-sm-4 hidden-xs col-md-6 action-table-map'>
        <span className='pull-right'>
          <button className='btn btn-primary' onClick={this._onClickSaveLayout} disabled={disableSaveLayoutButton}>Save Changes</button>{' '}
        </span>
      </div>
      <div className={styles.wrapper}>
        <div className='row'>
          <div className='col-md-12 col-sm-12 col-xs-12'>
            <span className='pull-left'>
              <ul>
                <li className={`${styles['li-filter']}`}>
                  <Field
                    name='outletIds'
                    component={DropdownOutlet}
                    outlets={outlets}
                    onChangeOutletIds={this._onChangeOutletIds}
                  />
                </li>
                <li className={`${styles['li-filter']} li-dropdown-category`}>
                  <Field
                    name='groupId'
                    component={DropdownSelect}
                    options={groupsSort}
                    defaultOption={{id: _id, name: _name}}
                    className='dropdown-select-group'
                    id='filterSelectGroup'
                    onChange={this._onChangeFilterGroup}
                    disabled={fieldDisabled}
                  />
                </li>
                <li className={`${styles['li-filter']}`}>
                  <button className='btn btn-default' onClick={this._onOpenAddTable} disabled={!groupDetail}>Add Table</button>
                </li>
              </ul>
            </span>
            <span className='pull-right'>
              <ul>
                <li className={`${styles['li-filter']}`}>
                  Status:{' '}<span className={activeStyle}>{_active}</span>
                </li>
              </ul>
            </span>
          </div>
        </div>
      </div>
    </div>)
  }

  _onOpenAddTable = () => {
    const {dispatch, tables} = this.props
    if (tables.length >= GRID_MAX) {
      dispatch(actNotif.error('Failed to add table.Table group capacity for this group reached'))
    } else {
      dispatch(initialize('addTableModal', {
        id: null,
        shape: 'Circle',
        maxPax: 1,
        name: ''
      }))
      dispatch(actTableManagement.openAddTableModal())
    }
  }

  _onClickSaveLayout = () => {
    const {dispatch, tables, originalTables, groupDetail} = this.props
    dispatch(actTableManagement.submitSaveLayout(tables, originalTables, groupDetail))
  }

  _onChangeFilterGroup = (e, groupId) => {
    e.preventDefault()
    const {tables, originalTables, dispatch, groupDetail} = this.props
    if (groupDetail) {
      dispatch(change('search', 'groupId', groupDetail.id))
    } else {
      dispatch(change('search', 'groupId', 0))
    }

    if (!_isEqual(tables, originalTables) && !this.props.nextAction) {
      dispatch(askConfirmAction(actTableManagement.dropDownSelectTableGroup(groupId)))
    } else {
      dispatch(actTableManagement.dropDownSelectTableGroup(groupId))
    }
  }

  _onChangeOutletIds = (outletIds) => {
    const {dispatch, tables, originalTables} = this.props
    if (!_isEqual(tables, originalTables) && !this.props.nextAction) {
      dispatch(askConfirmAction(actTableManagement.onChangeOutletIdsMap(outletIds)))
    } else {
      dispatch(actTableManagement.onChangeOutletIdsMap(outletIds))
    }
  }
}

const mapForm = {
  form: 'search'
}

const selector = formValueSelector('search')

function mapStateToProps (state) {
  let {groups, summary, groupDetail, currentPage, totalPage, outlets} = state.tableManagement.group
  let {tables, originalTables, disableSaveLayoutButton} = state.tableManagement.map
  return {
    outlets,
    groups,
    groupDetail,
    tables,
    originalTables,
    disableSaveLayoutButton,
    currentPage,
    totalPage,
    summary,
    groupId: selector(state, 'groupId')
  }
}

function mapDispatchToProps (dispatch) {
  return {dispatch: dispatch}
}

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm(mapForm)(ActionBar))



// WEBPACK FOOTER //
// ./app/pages/TableManagement/TableManagementMap/ActionBar/ActionBar.js